import Main from 'template/containers/Main'

export const RouteConfig = [
    {
        path: '/template',
        component: Main,
    },
]
